import { GoogleGenerativeAI } from "@google/generative-ai";

const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

if (!GEMINI_API_KEY) {
  throw new Error('Missing Gemini API key environment variable');
}

// Initialize the Gemini API client
const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

// Function to perform web search and get AI-generated response
export const testSearchQuery = async (query) => {
  try {
    const model = genAI.getGenerativeModel({
      model: 'gemini-2.0-flash',
      tools: [{
        googleSearch: {}
      }]
    });

    const result = await model.generateContent({
      contents: [{ 
        role: 'user',
        parts: [{ 
          text: `For the CSRD i would like to answer for the ESRS to following question : ${query}. Please structure your response in a clear and professional manner, using bullet points where appropriate. Include relevant sources in your response.`
        }]
      }]
    });

    if (!result || !result.response) {
      throw new Error('Failed to get response from AI model');
    }

    return result.response.text();
  } catch (error) {
    console.error('Error performing search query:', error);
    throw error;
  }
}; 